/**
 * Export settings dialog
 * 
 * @author JHO 
 * Last changed: 11.01.2021
 * Changes: PBI-723 Check if no conflicts
 */

import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import GetAppIcon from '@material-ui/icons/GetApp';
import * as constants from '../../../common/constants';
import FormControl from '@material-ui/core/FormControl';
import axios from 'axios';
import * as endpoints from '../../../service/endpoints';
import MuiAlert from '@material-ui/lab/Alert';
 

//size of  dialog
const useStyles = makeStyles((theme) => ({
    dialog: {
        minHeight: '50vh',
        maxHeight: '70vh',
        padding: theme.spacing(2)
     },
     root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    
        '& .MuiTextField-root': {
          margin: theme.spacing(1),
          width: '500px',
        },
        '& .MuiButtonBase-root': {
        },
      },
      formControl: {
        marginBottom: theme.spacing(2),
        minWidth: '200px'
      },
      button: {
        minWidth: '200px'
      },
      buttons : {
        position: 'absolute',
        right: theme.spacing(3),
        bottom: theme.spacing(3),
      }
}));

const ExportSettingsDialog = (props) => {
const classes = useStyles();
const { t } = useTranslation();

const config = {
    headers: { Authorization: `Bearer ${props.token}` }
  };


const [exportAllMeasures, setExportAllMeasures] = useState(1);
const [exportAllArticles, setExportAllArticles] = useState(false);
const [templates, setTemplates] = React.useState(Object.keys(props.csvConfig && props.csvConfig.templates));
const [template, setTemplate] = React.useState(props.csvConfig && props.csvConfig.templates[props.csvConfig.active] ? props.csvConfig.active : "new");

const handleChangeArticles = (event) => {
    setExportAllArticles(event.target.value)
};

const handleChangeMeasures = (event) => {
    setExportAllMeasures(event.target.value)
};

const handleChangeTemplate = (event) => {
      setTemplate(event.target.value);
  };

const handleSubmit = (event) => {
    event.preventDefault();
    let csvConfig = props.csvConfig;
    csvConfig.active = template;
    axios.patch(endpoints.PARAMETERS, csvConfig, config)
            .then(response => {
              props.setCSVConfig(csvConfig);
              window.localStorage.setItem("csvConfig", JSON.stringify(csvConfig));
            })
            .catch(error => {
              console.log(error)
            })
    props.handleSubmit(exportAllMeasures,exportAllArticles)
}

return (
    <Dialog classes={{ paper: classes.dialog }} fullWidth={true} maxWidth={'md'} open={props.open} onClose={props.handleClose}>
        <Typography variant="h5" color="black" gutterBottom>
                        {t('csv_export_header')}
        </Typography>
        <form className={classes.root} onSubmit={handleSubmit}>
            <TextField
                select
                label={t('measure_options')}
                value={exportAllMeasures}
                onChange={e => handleChangeMeasures(e)}
                variant="outlined"
                >
                {constants.MEASURE_EXPORT_OPTIONS.map((option) => (
                    <MenuItem key={option.key} value={option.value}>
                        {t(option.key)}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                select
                label={t('article_options')}
                value={exportAllArticles}
                onChange={e => handleChangeArticles(e)}
                variant="outlined"
                >
                {constants.ARTICLE_EXPORT_OPTIONS.map((option) => (
                    <MenuItem key={option.key} value={option.value}>
                        {t(option.key)}
                    </MenuItem>
                ))}
            </TextField>

            <FormControl component="fieldset" className={classes.formControl}>
            <TextField
                select
                label={t('settings_data_template')}
                value={template}
                onChange={e => handleChangeTemplate(e)}
                variant="outlined"
            >

                {templates.map((option) => (
                <MenuItem key={option} value={option}>
                    {option}
                </MenuItem>
                ))}
            </TextField>
            </FormControl>
            {(props.selectedDataConflicts && exportAllMeasures === constants.MEASURE_EXPORT_VALUES.SELECTED) &&
            (<MuiAlert severity="error">{t('must_conflict')}</MuiAlert>)}

            <div className={classes.buttons}>
                <Button className={classes.button} type="submit" variant="contained" color="secondary" textColor="white" startIcon={<GetAppIcon />} disabled={props.selectedDataConflicts > 0 && exportAllMeasures === constants.MEASURE_EXPORT_VALUES.SELECTED}>
                {t('button_export')}
                </Button>
            </div>
        </form>
    </Dialog>
    );
};

export default ExportSettingsDialog;